import { getLocalizedAttrValue, getLocalizedString } from "@grandvisionhq/utils";
const mapBundleChildLineItems = (lineItem, intl) => {
  return lineItem.bundleLineItems.map(
    (child) => toBundleChildLineItem(intl)(child)
  );
};
const toBundleChildLineItem = (intl) => (child) => {
  const lensColor = getLocalizedAttrValue(
    child.legacyProduct.masterData.current.variant,
    "lensColor",
    intl.locale
  );
  const productName = getLocalizedString(child.legacyProduct.masterData.current.name, intl.locale);
  const body = lensColor && !child.isMainBundleLineItem ? `${productName} - ${lensColor}` : productName;
  const title = child.isMainBundleLineItem ? intl.getLabel("cart.lineItem.glasses.bundleItem.frame") : intl.getLabel(`cart.lineItem.glasses.bundleItem.${child.legacyProduct.productType}`);
  return {
    title,
    body,
    type: child.legacyProduct.productType,
    originalPrice: child.price?.total.subtotal,
    price: child.price?.total.gross || 0,
    sku: child.sku
  };
};
export {
  mapBundleChildLineItems,
  toBundleChildLineItem
};
//# sourceMappingURL=map-bundle-child-line-items.js.map
